module.exports = __webpack_public_path__ + "img/ramp-right.834d0dd7.svg";